<div class="list-container">
  <div class="content">
    <ng-container [ngSwitch]="countType">
      <ng-container *ngSwitchCase="'leadCounts'">
        <app-lead-count-list [status]="status"></app-lead-count-list>
      </ng-container>
      <ng-container *ngSwitchCase="'appointmentCounts'">
        <app-appointment-list [apptStatus]="status"></app-appointment-list>
      </ng-container>
      <ng-container *ngSwitchCase="'customerVisitCounts'">
        <app-customer-visit-counts-list
          [status]="status"
        ></app-customer-visit-counts-list>
      </ng-container>
      <ng-container *ngSwitchCase="'proposalCounts'">
        <app-proposal-counts-list [status]="status"></app-proposal-counts-list>
      </ng-container>
      <ng-container *ngSwitchCase="'salesManagementCounts'">
        <app-sales-management-counts-list
          [status]="status"
        ></app-sales-management-counts-list>
      </ng-container>
      <ng-container *ngSwitchCase="'productionSchedulingCounts'">
        <app-production-scheduling-counts-list
          [status]="status"
        ></app-production-scheduling-counts-list>
      </ng-container>
      <ng-container *ngSwitchCase="'productionManagementCounts'">
        <app-production-management-counts-list
          [status]="status"
        ></app-production-management-counts-list>
      </ng-container>
      <ng-container *ngSwitchCase="'serviceCounts'">
        <app-service-counts-list [status]="status"> </app-service-counts-list>
      </ng-container>
      <ng-container *ngSwitchCase="'serviceManagementCounts'">
        <app-service-management-counts-list
          [status]="status"
        ></app-service-management-counts-list>
      </ng-container>
      <ng-container *ngSwitchCase="'permitCounts'">
        <app-permit-counts-list [status]="status"></app-permit-counts-list>
      </ng-container>
      <ng-container *ngSwitchCase="'utilityCounts'">
        <app-utility-counts-list [status]="status"></app-utility-counts-list>
      </ng-container>
      <ng-container *ngSwitchCase="'cclCounts'">
        <app-ccl-counts-list [status]="status"></app-ccl-counts-list>
      </ng-container>
      <ng-container *ngSwitchCase="'accountingCounts'">
        <app-accounting-counts-list
          [status]="status"
        ></app-accounting-counts-list>
      </ng-container>
    </ng-container>
  </div>
</div>
